import { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import AnalysisDashboard from "./analysis/AnalysisDashboard";
import styles from "./Analysis.module.css";

const Analysis = () => {
    const { isDarkMode } = useTheme();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'Analysis';
    }, []);

    // Extract current section from pathname for breadcrumb
    const getBreadcrumbItems = () => {
        const path = location.pathname;
        if (path === '/lab') return ['Analysis'];
        if (path === '/lab/manual-import') return ['Analysis', 'Manual Import'];
        if (path === '/lab/qc-batches') return ['Analysis', 'QC Batches'];
        if (path === '/lab/worklists') return ['Analysis', 'Worklists'];
        return ['Analysis'];
    };

    const breadcrumbItems = getBreadcrumbItems();
    const isOnDashboard = location.pathname === '/lab';

    return (
        <div className={styles.analysis}>
            <div className={styles.header}>
                <h1>Analysis</h1>
                <nav className={styles.breadcrumb}>
                    {breadcrumbItems.map((item, index) => (
                        <span key={index}>
                            {index === 0 ? (
                                <button 
                                    className={`${styles.breadcrumbItem} ${isOnDashboard ? styles.active : ''}`}
                                    onClick={() => navigate('/lab')}
                                >
                                    {item}
                                </button>
                            ) : index === breadcrumbItems.length - 1 ? (
                                <span className={`${styles.breadcrumbItem} ${styles.active}`}>
                                    {item}
                                </span>
                            ) : (
                                <button 
                                    className={styles.breadcrumbItem}
                                    onClick={() => {
                                        // Add navigation logic for other sections
                                    }}
                                >
                                    {item}
                                </button>
                            )}
                            {index < breadcrumbItems.length - 1 && (
                                <span className={styles.breadcrumbSeparator}>›</span>
                            )}
                        </span>
                    ))}
                </nav>
            </div>

            <div className={styles.content}>
                <Routes>
                    <Route index element={<AnalysisDashboard />} />
                    {/* Add more routes as needed */}
                </Routes>
            </div>
        </div>
    );
};

export default Analysis;
